import { rankingData } from '@/mocks/home';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-fire-line"></i>
              实时热度
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              今日吃瓜热度榜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              全网最热爆料实时排名，热度每分钟更新一次
            </p>
          </div>

          <div className="space-y-3">
            {rankingData.map((item) => (
              <div
                key={item.id}
                className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group cursor-pointer"
              >
                <div className={`flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center font-heading font-bold text-lg md:text-xl ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                      {item.category}
                    </span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold whitespace-nowrap ${
                      item.tag === '今日爆' ? 'bg-accent-500 text-background-50' :
                      item.tag === '独家' ? 'bg-primary-200 text-primary-800' :
                      'bg-secondary-200 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                </div>
                <div className="flex-shrink-0 text-right">
                  <div className="flex items-center gap-1 text-primary-500 font-bold text-sm md:text-base">
                    {item.trend === 'up' && <i className="ri-arrow-up-line text-xs"></i>}
                    {item.heat}
                  </div>
                  <div className="text-[10px] md:text-xs text-foreground-400">热度</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}